import type { AnyID } from '@types'
import { create } from 'zustand'

export type ModularToolbarScreenPos = {
  x: number
  y: number
  targetId: AnyID
}

type ModularUiStore = {
  itemDragActive: boolean
  toolbarScreenPos: ModularToolbarScreenPos | null
  setItemDragActive: (active: boolean) => void
  setToolbarScreenPos: (pos: ModularToolbarScreenPos | null) => void
}

export const useModularUiStore = create<ModularUiStore>((set) => ({
  itemDragActive: false,
  toolbarScreenPos: null,
  setItemDragActive: (itemDragActive) => set({ itemDragActive }),
  setToolbarScreenPos: (toolbarScreenPos) => set({ toolbarScreenPos }),
}))
